<template>
  <div class="container full-width"> 
    <!-- Start Modal -->
    <!-- Modal -->
    <div class="modal fade" id="errModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
            <!-- <h4 class="modal-title" id="myModalLabel">Votre message comporte les erreurs suivantes :</h4> -->
            <div class="modal-title" style="display: block;">
                <div class="arrow" style="margin-left: 0;"></div>
                <div class="h2-arrow" style="padding: 0;">
                  VOTRE MESSAGE A ÉTÉ REFUSÉ<br/>POUR LES RAISONS SUIVANTES :
                </div>
            </div>
          </div>
          <div id="error-modal-content" class="modal-body">
            <ul>
              <!-- <li v-for="(err, index) in errArray" class="error-list">
                {{err}}
              </li> -->
            </ul>
          </div>
          <div class="modal-footer">
            <button id="acknowlegdeButton" type="button" class="btn btn-default" data-dismiss="modal">Ok</button>
          </div>
        </div>
      </div>
    </div>
    <!-- End Modal -->

    <!-- Header Start -->
    <app-header></app-header>
    <!-- Header End -->

    <!-- div oblique -->
    <side-info :template="name" v-bind:style="[mainPaddingTop]" ref="sideInfo"></side-info>

    <div class="main" v-bind:style="mainPaddingTop">
      <div class="fil-ariane">Mon espace</div>
      <h1 class="page-title">Accueil de mon espace<span id="diff-en-cours-title" v-bind:style="welcomeMessages['currentDiffusionTitle']"> - ma diffusion en cours</span></h1>
      <div class="main-content">
        <div id="no-creation-yet" v-bind:style="welcomeMessages['noCreationYetDisplay']">
          <p style="margin-bottom: calc(100vh / (949 / 40));">
            Vous vous connectez pour la première fois ?<br/>Consultez <router-link to="/miscellanous/conseils-pratiques">nos conseils pratiques</router-link> avant de créer votre premier message promotionnel ou informatif.
          </p>
          <!-- ////////// -->
          <!-- 1st connection / warning-box start -->
          <div class="warning-box">
            <svg class="warning-box-icon" xmlns="http://www.w3.org/2000/svg" viewBox="9111 -944 57.608 43.621" style="fill: var(--error-primary-color);"><path class="a" d="M33.731,8.189a1.415,1.415,0,0,0-1.121.6L5.185,50.022a1.2,1.2,0,0,0,1.19,1.789H61.231a1.2,1.2,0,0,0,1.19-1.789L35,8.787a1.415,1.415,0,0,0-1.125-.6Zm.072,3.582,25.05,37.653H8.754Zm-.74,9.941c-.557,0-1.006.33-1.006.74V38.016c0,.41.449.742,1.006.742h1.474c.557,0,1.006-.332,1.006-.742V22.453c0-.411-.449-.74-1.006-.74Zm.74,22.026a1.536,1.536,0,1,0,1.751,1.52,1.648,1.648,0,0,0-1.751-1.52Z" transform="translate(9106.001 -952.189)"/></svg>       
            <div class="warning-text">
              <ul>
                <li>
                  Nous vous informons que tout message non conforme aux conditions<br/>d'utilisation que vous avez validées se verra automatiquement supprimé<br/>et sa diffusion annulée.
                </li>
              </ul>
            </div>
          </div>
          <!-- 1st connection / warning-box end -->
          <!-- warning-box end -->
          <router-link to="/app/creer-un-message" id="mentions-legales" class="btn btn-default btn-side-info" style="margin-top: calc(100vw / (1920 / 40));">
            CRÉER MON PREMIER MESSAGE
          </router-link>
        </div>
        <!--  -->
        <div id="no-creation-on" v-bind:style="welcomeMessages['noCreationOnDisplay']">
          <p style="margin-bottom: calc(100vh / (949 / 40));">
            Vous n'avez aucun message en cours.<br/>Consultez <router-link to="/miscellanous/conseils-pratiques">nos conseils pratiques</router-link> avant de créer votre message promotionnel ou informatif.
          </p>
          <!-- ////////// -->
          <!-- no message in diffusion / warning-box start -->
          <div class="warning-box">
            <svg class="warning-box-icon" xmlns="http://www.w3.org/2000/svg" viewBox="9111 -944 57.608 43.621" style="fill: var(--error-primary-color);"><path class="a" d="M33.731,8.189a1.415,1.415,0,0,0-1.121.6L5.185,50.022a1.2,1.2,0,0,0,1.19,1.789H61.231a1.2,1.2,0,0,0,1.19-1.789L35,8.787a1.415,1.415,0,0,0-1.125-.6Zm.072,3.582,25.05,37.653H8.754Zm-.74,9.941c-.557,0-1.006.33-1.006.74V38.016c0,.41.449.742,1.006.742h1.474c.557,0,1.006-.332,1.006-.742V22.453c0-.411-.449-.74-1.006-.74Zm.74,22.026a1.536,1.536,0,1,0,1.751,1.52,1.648,1.648,0,0,0-1.751-1.52Z" transform="translate(9106.001 -952.189)"/></svg>       
            <div class="warning-text">
              <ul>
                <li>
                  Nous vous informons que tout message non conforme aux conditions<br/>d'utilisation que vous avez validées se verra automatiquement supprimé<br/>et sa diffusion annulée.
                </li>
              </ul>
            </div>
          </div>
          <!-- no message in diffusion / warning-box end -->
          <!-- warning-box end -->
          <router-link to="/app/creer-un-message" class="btn btn-default btn-side-info" style="margin-top: calc(100vw / (1920 / 40));">
            CRÉER UN MESSAGE
          </router-link>
          <router-link to="/app/gerer-diffusion" class="btn btn-default btn-side-info" style="margin-top: calc(100vw / (1920 / 40));">
            GÉRER MA DIFFUSION
          </router-link>
        </div>
        <!--  -->
        <div id="current-creations" v-bind:style="welcomeMessages['currentCreationsDisplay']">
          <div class="info-box-main-home">
            <svg class="info-box-icon-main" xmlns="http://www.w3.org/2000/svg" viewBox="8949 -947 14.89 50"><path class="a" d="M30.19,997.365a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,30.19,997.365Zm0,16.541H22.56l.012,3,5.89-.021v27.5H22.556l.006,2.952,7.628.01,7.255.018-.006-2.97-5.519-.01v-27.5c0-2.991.046-2.987-1.73-2.987Z" transform="translate(8926.444 -1944.365)"/></svg>
            <div class="info-text-main-home">
              Pensez à vérifier que le texte de votre annonce est complet et bien lisible,<br/>et pensez bien qu'elle sera diffusée 6 secondes à chaque passage !
            </div>
          </div>
          <current-diffusion v-bind:slotLimit="slotLimit" v-bind:editEnabled="editEnabled" v-bind:userProps="userProps" v-bind:overDropZone="overDropZone" v-bind:terminalMediaArr="terminalMediaArr" v-bind:currentDraggedImg="currentDraggedImg"></current-diffusion>
          <!-- ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++ -->
          <router-link to="/app/creer-un-message" class="btn btn-default btn-side-info" style="margin-top: calc(100vw / (1920 / 15));">
            CRÉER UN MESSAGE
          </router-link>
          <router-link to="/app/gerer-diffusion" class="btn btn-default btn-side-info" style="margin-top: calc(100vw / (1920 / 15));">
            GÉRER MA DIFFUSION
          </router-link>
        </div>
      </div>
    </div>
    <!-- ////////////// Footer Start ////////////// -->
    <app-footer></app-footer>
    <!-- ////////////// Footer End ////////////// -->
    <!-- Button trigger modal -->
    <button id="modalButton" type="button" class="btn btn-primary btn-lg" data-toggle="modal" data-target="#errModal" style="visibility: hidden;">
      Launch modal
    </button>
  </div>
</template>

<script>
  const AppModules = require('annonces-app-modules')(process.env.APP_NAME, process.env.NODE_ENV)
  import setPaddingTop from '@/common/lib/setPaddingTop'
  import Header from '@/components/Header'
  import SideInfo from '@/components/SideInfo'
  import Footer from '@/components/Footer'
  import CurrentDiffusion from '@/components/CurrentDiffusion'
  export default {
    data () {
      return {
        name: 'Home',
        user: AppModules.getUser(),
        mainPaddingTop: {
          paddingTop: '0'
        },
        sideInfoBackground: {
          backgroundImage: 'none'
        },
        welcomeMessages: {
          currentDiffusionTitle: {
            display: 'none'
          },
          noCreationYetDisplay: {
            display: 'none'
          },
          noCreationOnDisplay: {
            display: 'none'
          },
          currentCreationsDisplay: {
            display: 'none'
          }
        },
        userProps: {},
        slotLimit: 0,
        overDropZone: false,
        editEnabled: 0,
        terminalMediaArr: [],
        currentDraggedImg: '',
        tootipId: null
      }
    },
    components: {
      'app-header': Header,
      'side-info': SideInfo,
      'app-footer': Footer,
      'current-diffusion': CurrentDiffusion
    },
    mounted: function () {
      var self = this
      return self.user.getProperties(function (err, userProps) {
        if (err) {
          console.log(err)
        }
        //
        self.userProps = userProps
        self.slotLimit = self.userProps.appData.slot_limit
        self.adjustPaddingTop()
        self.switchWelcomeMessage()
        //
        window.removeEventListener('resize', self.adjustPaddingTop, false)
        window.addEventListener('resize', self.adjustPaddingTop, false)
        //
        setTimeout(function () {
          return self.user.showWarnings(self.$router, function (err, status, data) {
            console.log('err : ', err, 'status : ', status, 'data : ', data)
          })
        }, 2000)
      })
    },
    methods: {
      findTerminalMedia: function (medias) {
        if (medias && medias.length > 0) {
          this.terminalMediaArr = []
          for (let i = 0; i < this.slotLimit; ++i) {
            let media = medias.find(function (item) {
              return item.media_content.diffusionIndex === i
            })
            //
            if (media) {
              this.terminalMediaArr.push(media)
            } else {
              this.terminalMediaArr.push(null)
            }
          }
        }
      },
      adjustPaddingTop: function () {
        var self = this
        return setPaddingTop(function (err, paddingTop) {
          if (err) {
            console.log(err)
          }
          self.mainPaddingTop.paddingTop = paddingTop + 'px'
            //
          if (self.userProps.module_boulangerie) {
            // self.sideInfoBackground.backgroundImage = 'url(/static/images/visuel_boulangerie-light.png)'
            self.sideInfoBackground.backgroundImage = 'url(/static/images/visuel_boulangerie_v1.png)'
            self.mainPaddingTop.paddingTop = paddingTop + 'px'
            return
          }
          if (self.userProps.module_fleuriste) {
            self.sideInfoBackground.backgroundImage = 'url(/static/images/visuel_fleuriste_v1.png)'
            self.mainPaddingTop.paddingTop = paddingTop + 'px'
            return
          }
          if (self.userProps.module_presse) {
            // self.sideInfoBackground.backgroundImage = 'url(/static/images/visuel_tabac-light.png)'
            self.sideInfoBackground.backgroundImage = 'url(/static/images/visuel_presse_v1.png)'
            self.mainPaddingTop.paddingTop = paddingTop + 'px'
            return
          }
        })
      },
      switchWelcomeMessage: function () {
        var self = this
        //
        function resetState () {
          for (var state in self.welcomeMessages) {
            self.welcomeMessages[state] = {display: 'none'}
          }
        }
        //
        function updateDisplay (medias, slotLimit) {
          if (medias.length === 0) {
            resetState()
            self.welcomeMessages['noCreationYetDisplay'] = {display: 'block'}
            return
          }
          // - - - - - - - - - - - - - - - -
          let currentMedias = self.terminalMediaArr.find(function (item) {
            return item !== null
          })
          if (!currentMedias) {
            resetState()
            self.welcomeMessages['noCreationOnDisplay'] = {display: 'block'}
            return
          }
          // - - - - - - - - - - - - - - - -
          resetState()
          self.welcomeMessages['currentCreationsDisplay'] = {display: 'block'}
          self.welcomeMessages['currentDiffusionTitle'] = {display: 'inline'}
          return
        }
        // - - - - - - - - - - - - - - - -
        return this.user.showCurrentMedia(function (err, medias, slotLimit) {
          if (err) {
            console.log(err)
            return
          }
          // - - - - - - - - - - - - - - - -
          self.findTerminalMedia(medias)
          console.log(`//////////////////////////////////////////// terminalMediaArr : `)
          console.log(self.terminalMediaArr[0])
          console.log(self.terminalMediaArr[1])
          // - - - - - - - - - - - - - - - -
          updateDisplay(medias, slotLimit)
          return
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .bmtv-tooltip.top .bmtv-tooltip-arrow {
    bottom: 20px;
    left: 50%;
    margin-left: -5px;
    border-width: 5px 5px 0;
    border-top-color: var(--grey-eighth-color);
  }

  .bmtv-tooltip-inner {
    padding: 3px 0;
    color: var(--secondary-color);
    text-align: center;
    background-color: var(--grey-eighth-color);
    border-radius: 4px;
    box-shadow: 0 2px 5px 0.2px rgba(0, 0, 0, 0.25);
  }

  .bmtv-tooltip-arrow {
    position: absolute;
    width: 0;
    height: 0;
    border-color: transparent;
    border-style: solid;
    box-sizing: border-box;
  }
  
  .bmtv-tooltip.top {
    padding: 5px 0;
    position: absolute;
  }

  .bmtv-tooltip {
    position: absolute;
    z-index: 1070;
    display: block;
    font-family: 'Open Sans', Arial;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: left;
    text-align: start;
    text-decoration: none;
    text-shadow: none;
    text-transform: none;
    letter-spacing: normal;
    word-break: normal;
    word-spacing: normal;
    word-wrap: normal;
    white-space: normal;
    line-break: auto;
    z-index: 999;
  }

  .bmtv-tooltip-left {
    min-width: 150px;
    height: 120px;
    right: calc(100vh / (1080 / 100));
    transform: skew(-5deg);
  }

  .bmtv-tooltip-right {
    min-width: 150px;
    height: 120px;
    left: calc(100vh / (1080 / 100));
    transform: skew(5deg);
  }

  .bmtv-tooltip-inner-item {
    letter-spacing: 0.4px;
    padding: 2px 8px;
    text-align: left;
    font-weight: normal;
    background-color: none;
    cursor: pointer;
  }

  .bmtv-tooltip-inner-item:hover {
    letter-spacing: 0;
    font-weight: bold;
    background-color: var(--grey-third-color);
  }

  /*
  .terminal-left-single {
    background-image: url(/static/images/terminal-left-single.svg);    
  }

  .terminal-left {
    background-image: url(/static/images/terminal-left.svg);    
  }

  .terminal-right {
    background-image: url(/static/images/terminal-right.svg);
    margin-left: calc(100vw / (1920 / 132));
  }

  .terminal-left, .terminal-right {
    background-position: 0 4px;
    background-repeat: no-repeat;
    width: calc(100vw / (1920 / 448));
    height: calc(100vw / (1920 / 320));
    display: inline-block;
    position: relative;
  }

  .terminal-left-single {
    background-position: 8px 0;
    background-repeat: no-repeat;
    width: calc(100vw / (1920 / 360));
    height: calc(100vw / (1920 / 251));
    display: inline-block;
    position: relative;
  }

  .terminal-monitor-left, .terminal-monitor-right {
    position: absolute;
    border: calc(100vw / (1920 / 7)) solid var(--grey-eighth-color);
    border-radius: calc(100vw / (1920 / 20));
    box-sizing: content-box;
    height: calc(100vw / (1920 / 172));
    width: calc(100vw / (1920 / 275));
  }

  .terminal-monitor-left {
    transform: skew(5deg);
    right: calc(100vw / (1920 / 3));
  }

  .terminal-monitor-right {
    transform: skew(-5deg);
    left: calc(100vw / (1920 / 3));
  }

  .terminal-monitor-left-img, .terminal-monitor-right-img {
    position: relative;
    border-radius: calc(100vw / (1920 / 14));
    box-sizing: content-box;
    height: calc(100vw / (1920 / 172));
    width: calc(100vw / (1920 / 275));
  }

  .slot-number-left, .slot-number-right {
    position: absolute;
    box-sizing: border-box;
    width: calc(100vw / (1920 / 119));
    height: calc(100vw / (1920 / 119));
    bottom: calc(100vw / (1920 / 17));
  }

  .slot-number-left span, .slot-number-right span {
    width: calc(100vw / (1920 / 119));
    height: calc(100vw / (1920 / 119));
    font-family: 'Open Sans', Arial;
    font-weight: 600;    
    color: var(--secondary-color); 
    display: table-cell;
    vertical-align: middle;
    text-align: center;
  }

  .slot-number-left {
    left: 0;
  }

  .slot-number-right {
    right: 0;
  }
  */

  #no-creation-on, #no-creation-yet {
    padding-top: calc(100vh / (949 / 50));
  }

  .columns {
      text-align: justify;
      -webkit-column-count: 2; /* Chrome, Safari, Opera */
      -moz-column-count: 2; /* Firefox */
      column-count: 2;
      -webkit-column-gap: 40px; /* Chrome, Safari, Opera */
      -moz-column-gap: 40px; /* Firefox */
      column-gap: 40px;
  }

  .contraintes-techniques {
    /* background-image: url(../assets/images/votre-espace-back-ground-green.jpg); */
    background-image: url(../assets/images/degrade-bordeaux-1.svg);
    background-color: var(--primary-color);
    background-size: cover;
    background-position: center 50ù;
    /* background-color: var(--green-third-color); */
    border-radius: 5px;
    color: var(--secondary-color);
    padding: 0 30px;
  }

  .contraintes-techniques p {
    padding: 0;
    font-size: 16px;
  }

  .contraintes-techniques ul li {
    font-size: 16px;
  }

</style>




// WEBPACK FOOTER //
// Home.vue?59898552